<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  computed: {
    buttons() {
      if (this.$route.path.startsWith("/sections")) {
        return [
          {
            label: "Sections",
            icon: "bi bi-grid-3x3-gap-fill",
            route: "sections-index",
          },
          {
            label: "Nouvelle section",
            icon: "bi bi-plus-square-fill",
            route: "sections-create",
          },
        ];
      }
      return [
        {
          label: "Articles",
          icon: "bi bi-box-seam-fill",
          route: "items-index",
        },
        {
          label: "Nouvel article",
          icon: "bi bi-plus-circle-fill",
          route: "items-create",
        },
        {
          label: "Prix articles",
          icon: "bi bi-currency-exchange",
          route: "items-prices-index",
        },
        {
          label: "Attribuer prix",
          icon: "bi bi-tag-fill",
          route: "items-prices-create",
        },
      ];
    },
  },
};
</script>
